<template>
	<BModal id="booking-update-modal"
		centered
		title="Update Your Booking"
		size="lg">
		<template v-if="booking">
			<BForm>
				<BFormGroup label="Hours" :state="getValidationState('hours')"
					:invalid-feedback="getValidationErrors('hours')">
					<BFormInput :model-value="hours" type="number"
						:min="0" :max="10"
						@update:model-value="hours = $event" />
				</BFormGroup>
				<BFormRow>
					<BCol>
						<BFormGroup label="Suburb" :state="getValidationState('suburb_id')"
							:invalid-feedback="getValidationErrors('suburb_id')">
							<multiselect
								ref="suburb_select" :model-value="suburb"
								class="booking-form-suburb-select"
								:options="suburbs"
								placeholder="Start typing to find your suburb"
								label="name"
								track-by="id"
								:internal-search="false"
								:clear-on-select="false"
								:preserve-search="true"
								@search-change="getSuburbs"
								@update:model-value="suburb = $event">
								<template #option="suburb">
									<span class="font-bold">{{ suburb.option.name }}</span> ({{ suburb.option.state }}
									{{ suburb.option.postcode }})
								</template>
							</multiselect>
						</BFormGroup>
					</BCol>
					<BCol>
						<BFormGroup label="Address" :state="getValidationState('address')"
							:invalid-feedback="getValidationErrors('address')">
							<BFormInput :model-value="address" @update:model-value="address = $event" />
						</BFormGroup>
					</BCol>
				</BFormRow>
			</BForm>
		</template>
		<template #footer>
			<div class="d-flex justify-content-end gap-sm">
				<BButton variant="light" @click="$bvModal.hide('booking-update-modal')">
					Close
				</BButton>
				<BButton variant="primary" :disabled="submitting"
					@click="handleSubmit">
					<BSpinner v-if="submitting" small
						class="mr-2"></BSpinner>
					Save Changes
				</BButton>
			</div>
		</template>
	</BModal>
</template>

<script>
	import { useValidation } from '@js/composables/useValidation.js';
	import Multiselect from 'vue-multiselect';
	import 'vue-multiselect/dist/vue-multiselect.min.css'
	import {urlify} from '@js/utilities/index.js';

	export default {
		components: {
			Multiselect,
		},
		props: {
			booking: {
				type: Object,
				required: true,
			}
		},
		emits: ['booking-updated'],
		setup() {
			return {
				...useValidation(),
			};
		},
		data() {
			return {
				hours: this.booking.hours,
				service: this.booking.service,
				address: this.booking.address,
				suburb: this.booking.suburb,
				suburbs: [],
				submitting: false,
			}
		},
		methods: {
			async handleSubmit() {
				this.submitting = true;

				await this.$axios.put(`/api/client/bookings/${this.booking.unique_id}`, {
					hours: this.hours,
					address: this.address,
					suburb_id: this.suburb.id,
				}).then(() => {
					this.$bvToast.toast('Booking updated successfully', {
						title: 'Success',
						variant: 'success',
						solid: true,
					})
					this.$emit('booking-updated')
					this.$bvModal.hide('booking-update-modal')
					this.clearErrors();
				}).catch(error => {
					this.handleError(error);
				})

				this.submitting = false;
			},
			async getSuburbs(query) {
				if (!query) return []
				if (this.cancelToken) this.cancelToken.cancel()

				const CancelToken = this.$axios.CancelToken
				const queryString = urlify(query)

				this.cancelToken = CancelToken.source()

				return this.$axios.get(`/api/suburbs/list/${queryString}`, {
					cancelToken: this.cancelToken.token,
					params: {
						country: this.country
					}
				}).then((response) => {
					this.suburbs = response.data
				}).catch((error) => {
					if (this.$axios.isCancel(error)) {
						return;
					}

					throw error;
				})
			},
		}
	}
</script>
